import {Component, HostBinding} from '@angular/core';

const componentBaseName = 'app';
const defaultClassNames = ['cat-' + componentBaseName + '-component'].join(' ');

/**
 * The root component of the application
 * It provides:
 * - the skeleton for router outlets (content injection)
 * - global notification setup
 * - a loader overlay that is triggered at every xhr-request
 * - the global navigation bar
 */
@Component({
  selector: 'cat-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  @HostBinding('class') classNames = defaultClassNames;
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/base-app/components/app-component/app.component.ts